import { Dependent, Dependents } from './dependents-model';

export const getDependentByNumber = (dependents: Dependents, guid: string): Dependent => {
    if (!guid) return null;

    const allDependents = dependents.children.concat(dependents.domesticPartners);

    return allDependents.filter(d => d.person_guid === guid)[0];
};
